import React from "react";
import { Box, Center, Text } from "@chakra-ui/react";
import { useSelector } from 'react-redux';
import TextMyFont from "../../textsPanel/TextMyFont";
import { useTranslation } from "react-i18next";

const BrandkitFontsList = (props) => {
  const selectedBrandkit = useSelector((state) => state.brandKit.selectedBrandkit);

  const { t } = useTranslation(["planner"]);

  const { canvasRef, header } = props;
  const { fonts } = selectedBrandkit;

  return (
    <Box mb={3}>
      {header}

      {fonts.length > 0 ? (
        <>
          {fonts.map((font, index) => (
            <TextMyFont
              key={index}
              font={font}
              brandKitId={selectedBrandkit.id}
              addToArtboard={true}
              canvasRef={canvasRef}
            />
          ))}
        </>
      ) : (
        <Center>
            <Text
              color="gray.300"
              fontSize="1rem"
            >
              {t("brandkit.no_fonts_message")}
          </Text>
        </Center>
      )}
    </Box>
  );
};

export default BrandkitFontsList;